<div
  class="video-container"
  [class.fullscreen]="isFullScreen"
  (mousemove)="showControls()"
>
  <!-- Video -->
      <video
      #videoPlayer
      class="video-element"
      (timeupdate)="updateProgressBar(); updateBuffered()"
      (progress)="updateBuffered()"
      (waiting)="showLoader()"
      (canplay)="hideLoader()"
    >
    <source [src]="srcVideo" type="video/mp4" />
    Your browser does not support the video tag.
  </video>

  <!-- Loader -->
  <div class="spinner" *ngIf="isLoading"></div>

  <!-- Center Play -->
    <div
    class="center-play-button"
    [class.hidden]="isPlaying"
  >

    <button class="play-circle" (click)="togglePlayPause()" aria-label="پخش ویدیو">
  
  <i *ngIf="!isPlaying" class="play-icon-white w-10"></i>
  
  <i *ngIf="isPlaying" class="pause-icon w-10"></i>
  
  </button>
  
  </div>

  <!-- Controls -->
  <div class="controls" [class.hidden]="!controlsVisible">

    <!-- Play -->
    <button
      class="control-btn"
      (click)="togglePlayPause()"
      aria-label="پخش یا توقف"
    >
      <i *ngIf="!isPlaying" class="play-icon-blue w-5"></i>
      <i *ngIf="isPlaying" class="pause-icon-blue w-7"></i>
    </button>

    <!-- Progress -->
    <div class="progress-wrapper">

      <span class="time-video">
        {{ formatTime(currentTime) }}
      </span>
    
      <!-- ✅ اینو اینجا بذار -->
      <div class="progress-bar-wrapper">
    
        <div class="buffered-bar"
             [style.width.%]="bufferedPercent">
        </div>
    
        <input
          #progressBar
          type="range"
          min="0"
          [max]="videoPlayer?.duration || 0"
          step="0.1"
          [(ngModel)]="currentTime"
          (input)="seekVideo()"
        />
    
      </div>
    
      <span class="time-video">
        {{ formatTime(videoPlayer?.duration || 0) }}
      </span>
    
    </div>


    <!-- Fullscreen -->
    <button
      class="control-btn"
      (click)="toggleVideoScreen()"
      aria-label="تمام صفحه"
    >
      <i
        *ngIf="!isFullScreen"
        class="full-screen-icon w-6"
      ></i>

      <i
        *ngIf="isFullScreen"
        class="normal-screen-icon w-7"
      ></i>
    </button>

  </div>
</div>